<my-bill-scroll-to-top></my-bill-scroll-to-top>
<section class="rs-content-wrapper rs-header-has-level2">
  <main id="maincontent" role="main">
    <section class="mypxs-ch rs-neg rs-overlapped">
      <div class="row">
        <div class="columns small-12 medium-10">
          <ng-container *ngIf="hasCommonHeader">
            <my-bill-back-button
              [backButtonType]="'leftArrowPlainText'"
              [shouldGoBackToOverview]="shouldGoBackToOverview"
            ></my-bill-back-button>
            <my-bill-odb-bill-document-info
              [customTitle]="customTitle"
              [billingDocument]="billingDocument"
            ></my-bill-odb-bill-document-info>
          </ng-container>
          <ng-content
            select="[customHeader]"
            *ngIf="hasCustomHeader"
          ></ng-content>
        </div>
      </div>
    </section>
    <section class="rs-overlapping">
      <div class="rs-fe3"></div>
      <div class="row">
        <div class="columns small-12">
          <div class="row rs-xpandgrid">
            <div class="columns small-12" *ngIf="hasTopContent">
              <ng-content select="[topContent]"></ng-content>
            </div>
            <div class="columns small-12" [ngClass]="leftColumnWidth">
              <ng-content select="[leftColumnContent]"></ng-content>
            </div>
            <div class="columns small-12" [ngClass]="rightColumnWidth">
              <ng-content select="[rightColumnContent]"></ng-content>
            </div>
            <div class="columns small-12" *ngIf="hasBottomContent">
              <ng-content select="[bottomContent]"></ng-content>
            </div>
          </div>
        </div>
      </div>
      <div class="rs-le2"></div>
    </section>
  </main>
</section>
